<web-design-system-modal [headline]="'trade.multi-order.positions.headline' | transloco" (dismiss)="activeModal.close()">
  <div class="input-group-material mb-2 keepcolor">
    <input type="text" [formControl]="currentFilter" [placeholder]="'trade.multi-order.positions.placeholder' | transloco" />
  </div>
  @if (error) {
    <p class="text-color-error mt-2">{{ error | transloco }}</p>
  }
  @if (groupedPositions$ | async; as groupedPositions) {
    @if ((positionsFacade.positionsLoading$ | async) === false && !groupedPositions.length) {
      @if (!currentFilter.value) {
        <p class="text-color-error">{{ 'trade.multi-order.positions.no-positions' | transloco }}</p>
      } @else {
        <p class="text-color-error">{{ 'trade.multi-order.positions.filter-error' | transloco }}</p>
      }
    }
    <div class="positions-container">
      @for (group of groupedPositions; track group.type) {
        <div class="group-type">{{ 'trade.multi-order.positions.' + group.type | transloco }}</div>
        @if (group.type === disallowedInstrumentType) {
          <div class="disallowed-hint">{{ 'trade.multi-order.positions.disallowed-hint' | transloco }}</div>
        }
        @for (position of group.positions; track position.isin; let isLast = $last) {
          <div class="position" [class.disabled]="isPicking || position.type === disallowedInstrumentType" (click)="pickPosition(position)">
            <div class="row align-items-center no-select">
              <div class="col">
                <div class="font-bold">{{ position.longName }}</div>
                <div>{{ position.type === disallowedInstrumentType ? position.shortName : position.isin }}</div>
              </div>
              <div class="col-2 text-right pr-4">
                @if (position.isin | hasMultiOrderInstrument: currentInstruments : 'sell') {
                  <svg class="icon icon-18">
                    <use xlink:href="/assets/img/svgs/svgset.svg#check" />
                  </svg>
                } @else {
                  <svg class="icon icon-18">
                    <use xlink:href="/assets/img/svgs/svgset.svg#add" />
                  </svg>
                }
              </div>
            </div>
          </div>
          @if (!isLast) {
            <hr />
          }
        }
      }
    </div>
  }
</web-design-system-modal>
